import React, { Suspense } from 'react';
import Grid from '@mui/material/Grid';
import Tabs from '@mui/material/Tabs';
import createLabelWithIcon from '#component/icon/label-icons';
import PreloaderComponent from '#component/preloader';
import DeviceEvents from '#component/device/overview/events/index';
import Sidebar from '#component/sidebar';
import Timeline from '#component/shipment/overview/shipment-timeline/timeline';
import SidebarDevices from '#component/sidebar/devices/index';
import { MeasurementsWrapper, TabCnt, TabBar, StyledTab, Divider } from '#component/shipment/overview/style';

const MAP_TAB = 90;
const EVENTS_TAB = 100;
const TIMELINE_TAB = 110;
const DEVICE_TAB = 120;

function DesktopView(props) {
  const {
    identifiersLoading,
    DeviceMeasurements,
    selectedDevices,
    rangeInterval,
    isWidthDownMd,
    MapComponent,
    parentState,
    isAppliance,
    tabProps,
    identifiers,
    rangeStart,
    isInRange,
    rangeEnd,
    setChart,
    account,
    history,
    events,
    match,
    tab,
    headerHeight,
    sidebarProps,
    sidebarSharedProps,
    sidebarComponentsProps,
    sidebarComponentsProps: {
      shipment: { delivery = [] } = {},
      identifiersMap
    },
    sidebarSharedProps: { setClickedEvents },
    sidebarDevicesProps,
    handleMeasurementClick,
    sidebarDevicesProps: { devicesWithExcursions },
    settingsThresholds
  } = props;

  const timelineIconLabel = createLabelWithIcon('timeline', TIMELINE_TAB === tab, true);
  const devicesIconLabel = createLabelWithIcon('devices', DEVICE_TAB === tab, true, sidebarDevicesProps);
  const eventsIconLabel = createLabelWithIcon('events', EVENTS_TAB === tab, true);
  const mapIconLabel = createLabelWithIcon('map', MAP_TAB === tab, isWidthDownMd || identifiers.length > 4);

  const excursionedTabs = devicesWithExcursions ? devicesWithExcursions.reduce((a, c) => {
    c.excursions.forEach(e => (a[e.id] = true));
    return a;
  }, {}) : {};

  return (
    <Grid container spacing={2} className="contentCnt" style={{ height: `calc(100% - ${headerHeight}px)` }}>
      { isWidthDownMd ? null :
      <Sidebar
        history={history}
        account={account}
        {...sidebarProps}
        {...sidebarSharedProps}
        sidebarComponentsProps={sidebarComponentsProps}
        sidebarDevicesProps={sidebarDevicesProps}
      />}
      <MeasurementsWrapper
        item
        xs={12}
        md={9}
      >
        {!identifiersLoading ? (
          <>
            <TabCnt>
              <TabBar
                position="static"
                color="default"
                elevation={0}
              >
                <Tabs value={tab} variant="scrollable">
                  {isWidthDownMd && identifiersMap['0'] === 'timeline' &&
                    <StyledTab label={timelineIconLabel} {...tabProps(TIMELINE_TAB)} />}
                  {isWidthDownMd &&
                    <StyledTab label={devicesIconLabel} {...tabProps(DEVICE_TAB)} />}
                  {isWidthDownMd &&
                    <StyledTab label={eventsIconLabel} {...tabProps(EVENTS_TAB)} />}
                  {identifiers.map((identifier, index) => {
                    const isActive = index === tab;
                    const isMobile = isWidthDownMd || identifiers.length > 4;
                    const label = createLabelWithIcon(
                      identifier,
                      isActive,
                      isMobile,
                      { isExcursion: excursionedTabs[identifier] }
                    );
                    return <StyledTab
                      key={identifier}
                      title={identifier}
                      label={label}
                      {...tabProps(index, excursionedTabs[identifier])}
                    />;
                  })}
                  <StyledTab label={mapIconLabel} title="MAP" {...tabProps(MAP_TAB)} />
                </Tabs>
              </TabBar>
              <Divider />
            </TabCnt>
            {identifiers[tab] && (parentState[`${identifiers[tab]}Loading`] === false ? (
              <Suspense fallback={<PreloaderComponent style={{ transform: 'initial' }} />}>
                <DeviceMeasurements
                  selectedDevices={selectedDevices}
                  events={events}
                  isInRange={isInRange}
                  range={{
                    rangeStart,
                    rangeEnd,
                    rangeInterval
                  }}
                  setChart={setChart}
                  match={match}
                  identifier={identifiers[tab]}
                  isAppliance={isAppliance}
                  clickEvents={setClickedEvents}
                  clickMeasurement={handleMeasurementClick}
                  settingsThresholds={settingsThresholds}
                />
              </Suspense>
            ) : (
              <PreloaderComponent style={{ transform: 'initial' }} />
            ))}
            {tab === TIMELINE_TAB && isWidthDownMd && (
              <Timeline
                delivery={delivery}
                {...sidebarComponentsProps}
              />
            )}
            {tab === DEVICE_TAB && isWidthDownMd && (
              <SidebarDevices {...sidebarDevicesProps} />
            )}
            {tab === EVENTS_TAB && isWidthDownMd && (
              <DeviceEvents
                events={events}
                history={history}
                account={account}
              />
            )}
            { tab === MAP_TAB && MapComponent }
          </>
        ) : (
          <PreloaderComponent style={{ transform: 'initial' }} />
        )}
      </MeasurementsWrapper>
    </Grid>
  );
}

export default DesktopView;
